<template>
	<div class="o-dashboard">
        <c-table
            :filters="[ 
                { name: 'client', label: 'Alle eindklanten', options: endClients},
                { name: 'reseller', label: 'Alle resellers', options: resellers }
            ]"
            ref="table"
            :columns="columnsProducts"
            :endpoint="'/api/productswitheolitems'"
            :placeholder="'Zoeken op productnaam, eindklant, reseller of artikelnummer '">
        </c-table>
	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';

export default {
	mixins: [ View, Form ],
	components: { CTable },
	data() {
		return {

		}
	},
	methods: {
        exportEOL() {

            let filterParams = '';
            for (const [key, value] of Object.entries(this.$refs.table.selection.filters)) {
                if (value !== null && value !== '') {
                    filterParams += `&filters[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`;
                }
            }

            const link = document.createElement('a');
            link.href = '/api/exporteolproducts?search=' + this.$refs.table.selection.search.all + '&sort=' + this.$refs.table.sort.column + '&order=' + this.$refs.table.sort.direction + filterParams;
            document.body.appendChild(link);
            link.click();
        }
	},
	computed: {
		columnsProducts() {
			return [
				{ name: 'name', label: 'Productnaam', sortable: true, sort: true },
				{ name: 'article_number', label: 'Artikelnr', sortable: true },
				{ name: 'eol_items', label: 'Aantal', sortable: true },
				{ name: 'client.name', label: 'Eindklant', sortable: true },
				{ name: 'client.parent.name', label: 'Reseller', sortable: true },
				{ name: "id", label: "", component: 'CColumnButton', props: { route: 'EOLDetail' }},
			];
		},
        resellers() {
			return this.$store.getters['filters/allResellers'];
		},
		endClients() {
			return this.$store.getters['filters/allEndClients'];
		}
	},
    beforeUnmount(){
        this.$store.dispatch('listener/off', {
            event: 'exportEOL',
            listener: this.exportEOL
        });
    },
    created(){
        this.$store.dispatch('listener/on', {
            event: 'exportEOL',
            listener: this.exportEOL
        });
    },
    beforeMount(){
        this.$store.dispatch('filters/fetchEndClients');
        this.$store.dispatch('filters/fetchResellers');
    },
}
</script>
